<!--Only shows on Desktop views-->
@if (!hideBreadcrumb) {
  <h2 class="col d-none d-lg-block">
    @for (breadcrumb of breadcrumbs.slice(0, breadcrumbs.length - 1); track breadcrumb) {
      <span>
        <ng-container *ngTemplateOutlet="breadcrumbTemplate; context: breadcrumb" />
        >
      </span>
    }
    <ng-container *ngTemplateOutlet="breadcrumbTemplate; context: breadcrumbs[breadcrumbs.length-1]" />
  </h2>
}

<!--Only shows on tablet views-->
@if (!hideBreadcrumb) {
  <h2 class="col d-none d-md-block d-lg-none">
    @if (previous) {
      <a [routerLink]="previous.route">
        <i class="fas fa-chevron-left"></i>
      </a>
    }
    <ng-container *ngTemplateOutlet="breadcrumbTemplate; context: breadcrumbs[breadcrumbs.length-1]" />
  </h2>
}

<!--Only shows on mobile views-->
@if (!hideBreadcrumb) {
  <div class="row d-md-none">
    <div class="col-2 my-auto">
      @if (previous) {
        <a class="float-left mobile-text-left d-inline" [routerLink]="previous.route">
          <i class="fas fa-2x fa-arrow-circle-left mx-5"></i>
        </a>
      }
    </div>
    <div class="col-10 my-auto">
      <h5 class="d-inline ml-5 mb-0 float-right">
        <ng-container *ngTemplateOutlet="breadcrumbTemplate; context: breadcrumbs[breadcrumbs.length-1]" />
      </h5>
    </div>
  </div>
}

<ng-template #breadcrumbTemplate let-clickable="clickable" let-route="route" let-title="title">
  @if (clickable) {
    <a class="breadcrumb-link" [routerLink]="route">{{title}}</a>
  } @else {
    {{title}}
  }
</ng-template>
